// extracted by mini-css-extract-plugin
export var buttonContainer = "_91-1";
export var fontSizeSelect = "_91-3";
export var formatSelect = "_91-2";
export var formats = "_91-4";
export var hidden = "_91-5";
export var icon = "_91-6";
export var select = "_91-0";